export default __webpack_public_path__ + "static/media/5.37207b67.jpg";